var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6835 26.1746C18.2484 25.7406 18.2484 25.0371 18.6835 24.6032L25.6956 17.6111L4.61428 17.6111C3.99888 17.6111 3.5 17.1137 3.5 16.5C3.5 15.8864 3.99888 15.3889 4.61428 15.3889L25.6956 15.3889L18.6835 8.39679C18.2484 7.96287 18.2484 7.25935 18.6835 6.82544C19.1187 6.39152 19.8242 6.39152 20.2593 6.82544L29.1736 15.7143C29.6088 16.1482 29.6088 16.8518 29.1736 17.2857L20.2593 26.1746C19.8242 26.6085 19.1187 26.6085 18.6835 26.1746Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.4dfc0662d33fdc391ae4e64017d9a7cf.svg";
export { ForwardRef as ReactComponent };